import currency from './currency';
import hours from './hours';

export default {
    currency,
    hours
}
